import { useState } from 'react'
import { CardContainer, VerticalContainer, VerticalMainContainer } from '@shared/designSystem/Containers'
import { H1Title, H2Title } from '@shared/designSystem/Titles'
import { Text } from '@shared/designSystem/Texts'
import { Flap } from '@shared/models/Flap'
import { TabScreenSleek } from '@shared/designSystem/TabScreen'
import designSystemStyles from '@shared/styles/designSystemStyles'

const TabSleekShowcaseScreen = () => {
    const [clickedScreen, setClickedScreen] = useState<string>('usuarios')

    const flaps: Flap[] = [
        {
            id: 'usuarios',
            label: 'Usuarios'.localized(),
            content: (
                <CardContainer>
                    <Text text="Contenido de Usuarios" />
                </CardContainer>
            )
        },
        {
            id: 'dispositivos',
            label: 'Dispositivos'.localized(),
            content: (
                <CardContainer>
                    <Text text="Contenido de Dispositivos" />
                </CardContainer>
            )
        },
        {
            id: 'bloqueado',
            label: 'Bloqueado'.localized(),
            isLocked: true,
            content: (
                <CardContainer>
                    <Text text="Este contenido está bloqueado" />
                </CardContainer>
            )
        }
    ]

    return (
        <VerticalMainContainer>
            <VerticalContainer gap={designSystemStyles.gapSm} alignment="left">
                <H1Title text="TabScreenSleek Showcase" />
                <H2Title text="Segmented control" />
                <TabScreenSleek
                    title=""
                    flaps={flaps}
                    clickedScreen={clickedScreen}
                    setClickedScreen={setClickedScreen}
                />
            </VerticalContainer>
        </VerticalMainContainer>
    )
}

export default TabSleekShowcaseScreen
